var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog", class: { active: _vm.showDialog } },
    [
      _c(
        "div",
        {
          staticClass:
            "dialog--content u-extra-medium-padding--bottom c-vehicle-modal",
        },
        [
          _c("h4", { staticClass: "u-extra-small-margin--bottom" }, [
            _vm._v(
              _vm._s(_vm.$t("kolonne.vehicle.title.modal")) + "\n      \n    "
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
              },
              [
                _c(
                  "div",
                  { staticClass: "loading-spinner-wrapper" },
                  [
                    _c("v-page-loading", {
                      attrs: { position: "absolute", right: "" },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "h5",
            { staticClass: "u-color--primary u-extra-small-margin--bottom" },
            [
              _vm._v(
                _vm._s(_vm.$t("kolonne.title")) +
                  " " +
                  _vm._s(_vm.current_kolonne_number)
              ),
            ]
          ),
          _vm._v(" "),
          _vm.current_kolonne_id == ""
            ? _c("p", { staticClass: "is-error" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("kolonne.error.nokolonne")) +
                    "\n    "
                ),
              ])
            : _c(
                "div",
                [
                  _c("form", { on: { submit: _vm.submitForm } }, [
                    _c(
                      "div",
                      { staticClass: "grid-x grid-margin-x align-bottom" },
                      [
                        _c("div", { staticClass: "cell shrink" }, [
                          _c("label", { attrs: { for: "vehicle" } }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("kolonne.vehicle.select.label")) +
                                " "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              staticClass: "form-control form-control--select",
                              attrs: { name: "vehicle", id: "vehicle" },
                            },
                            _vm._l(
                              this.vehicleOptions,
                              function (option, index) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: option.value },
                                  },
                                  [
                                    _vm._v(
                                      "\n                   " +
                                        _vm._s(option.value) +
                                        "\n                 "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cell auto" }, [
                          _c("label", { attrs: { for: "licensenumber" } }, [
                            _vm._v(_vm._s(_vm.$t("kolonne.vehicle.number"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control--small",
                            attrs: {
                              required: "",
                              type: "text",
                              name: "licensenumber",
                              id: "licensenumber",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "button",
                            {
                              staticClass: "c-vehicle__button--add",
                              attrs: { title: _vm.$t("create_new") },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "u-icon--add",
                                  attrs: { role: "presentation" },
                                },
                                [
                                  _c("use", {
                                    attrs: {
                                      "xlink:href": "/dist/sprite.svg#icon-add",
                                      href: "/dist/sprite.svg#icon-add",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  this.vehicles.length === 0
                    ? _c(
                        "p",
                        { staticClass: "u-color--alert text-center h6" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("kolonne.message.novehicles")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.vehicles.length >= 1
                    ? [
                        _c(
                          "h6",
                          {
                            staticClass:
                              "u-color--primary u-extra-small-margin--bottom u-extra-small-margin--top",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("kolonne.vehicle.title.addedvehicles")
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "c-vehicle-modal__vehicle-list" },
                          _vm._l(this.vehicles, function (item, index) {
                            return _c("li", { key: index }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.type) +
                                  ": " +
                                  _vm._s(item.number) +
                                  " \n                \n                "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "c-vehicle__button--delete",
                                  attrs: { title: _vm.$t("delete") },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.deleteVehicle(index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "u-icon--delete",
                                      attrs: { role: "presentation" },
                                    },
                                    [
                                      _c("use", {
                                        attrs: {
                                          "xlink:href":
                                            "/dist/sprite.svg#icon-delete",
                                          href: "/dist/sprite.svg#icon-delete",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCloseDialog.apply(null, arguments)
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }